var map = {
	"./MDA1.png": 3761,
	"./contracts-banner.jpg": 5048,
	"./logo_img_1.jpg": 2749,
	"./logo_img_2.jpg": 3794,
	"./logo_img_3.jpg": 175,
	"./logo_img_4.jpg": 3796
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7938;